var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MulReportHeader',{ref:"marketDataRef",attrs:{"dataFrom":_vm.table.params,"loading":_vm.loading,"toPdf":_vm.toPdf},on:{"search":_vm.searchData}}),_c('Table',{ref:"tableRef",attrs:{"border":"","columns":_vm.table.columns,"data":_vm.table.data,"max-height":_vm.maxHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }